import moment from "moment";

export function convertHourstoArray({
    startHours, endHours
}) {
    let hours = []

    if (!startHours || !endHours) {
        return hours
    }

    let startH = Number(startHours.split(":")[0])
    let endH = Number(endHours.split(":")[0])
    for (let i = startH; i < endH; i++) {
        hours.push(`${i < 10 ? 0 : ''}${i}:00`)
    }
    return hours
}

export function groupSession(
    userSessions
) {
    let newOrder = []
    for (let i = 0; i < userSessions.length; i++) {
        if (newOrder.length == 0) {
            newOrder.push({
                date: userSessions[i].date,
                courts: [{
                    ...userSessions[i].court,
                    hours: [...userSessions[i].hours]
                }],
            })
        } else {
            let similiarDate = false
            for (let j = 0; j < newOrder.length; j++) {
                if (newOrder[j].date === userSessions[i].date) {
                    similiarDate = true
                    let courts = newOrder[j].courts
                    let similiarCourts = false
                    for (let k = 0; k < courts.length; k++) {
                        if (courts[k]._id.toString() == userSessions[i].court._id.toString()) {
                            courts[k].hours = courts[k].hours.concat(userSessions[i].hours)
                            courts[k].hours = bubbleSort(courts[k].hours)
                            similiarCourts = true
                        }
                    }
                    if (!similiarCourts) {
                        newOrder[j].courts.push({
                            ...userSessions[i].court,
                            hours: [...userSessions[i].hours]
                        })
                    }
                }
            }
            if (!similiarDate) {
                newOrder.push({
                    date: userSessions[i].date,
                    courts: [{
                        ...userSessions[i].court,
                        hours: [...userSessions[i].hours]
                    }],
                })
            }
        }
        // sort date
    }
    newOrder.sort((a, b) => (a.date > b.date) ? 1 : ((b.date > a.date) ? -1 : 0))
    return newOrder
}

function bubbleSort(arr) {
    var i, j;
    var len = arr.length;
    var isSwapped = false;
    for (i = 0; i < len; i++) {
        isSwapped = false;
        for (j = 0; j < (len - i - 1); j++) {
            if (arr[j] > arr[j + 1]) {
                var temp = arr[j]
                arr[j] = arr[j + 1];
                arr[j + 1] = temp;
                isSwapped = true;
            }
        }
        if (!isSwapped) {
            break;
        }
    }
    return arr
}

export function sortHours(arr) {
    return [...arr].sort((a, b) => {
        const hourA = Number(a.split(':')[0]);
        const hourB = Number(b.split(':')[0]);
        return hourA - hourB;
    });
};

export const getDateRangeFromSchedule = (scheduleInfo = []) => {
    if (!scheduleInfo.length) {
        return {
            startDate: null,
            endDate: null
        };
    }

    let dates = scheduleInfo
        .map(item => moment(item.date))
        .filter(d => d.isValid());

    let startDate = moment.min(dates);
    let endDate = moment.max(dates);

    return {
        startDate: startDate.toDate(),
        endDate: endDate.toDate()
    };
};